import avalon from "avalon";
import $ from "jquery";
import ajax from "ajax";
import tool from "toolLoaderPC";
import dialog from "dialog";
import popup from "popup";
import pagination from "pagination";
import "laydate";

var managePop;
// 初始化置顶开始时间
var start = {
    elem: "#start_time",
    format: "YYYY/MM/DD",
    min: window.laydate.now(), // 设定最小日期为当前日期
    max: "2099-06-16 23:59:59", // 最大日期
    istime: true,
    istoday: false,
    choose: function(datas) {
        vmodel.startTime = datas;
        end.min = datas; // 开始日选好后，重置结束日的最小日期
        end.start = datas; // 将结束日的初始值设定为开始日
    }
};
// 初始化置顶结束时间
var end = {
    elem: "#end_time",
    format: "YYYY/MM/DD",
    min: window.laydate.now(),
    max: "2099-06-16 23:59:59",
    istime: true,
    istoday: false,
    choose: function(datas) {
        vmodel.endTime = datas;
        start.max = datas; // 结束日选好后，重置开始日的最大日期
    }
};

function exchange(el) {
    if (el.isPraise) {
        el.isPraise = 0;
        el.praise_num -= 1;
    } else {
        el.isPraise = 1;
        el.praise_num += 1;
    }
}

var vmodel = avalon.define({
    $id: "articleController",
    articleId: "", // 帖子id
    title: "",
    loadBottomHTML: "", // 上拉刷新顶部文字
    loadBottomDisplay: false,
    // loadingBottom: false,
    // maskManage: false,      // 遮罩层的控制
    //
    replyNum: 0, // 留言条数
    // start: 0,				// 当前加载的起始位置
    isPraise: 0, // 是否下沉
    isTop: 0, // 是否置顶
    isCream: 0, // 是否加精
    isVip: 0, // 是否是会员
    isHouse: 0, // 文章已收藏
    praiseNum: 0, // 点赞的人数
    // houseNum: 0,			// 收藏人数
    // praiseList: [],			// 点赞的用户列表
    // isShare: 0,             // 是否分享
    // shareNum: 0,            // 分享的人数
    // shareList: [],          // 分享的列表

    replys: [], // 评论数组
    page: {
        // 页码
        page: 0,
        page_size: 20,
        page_total: 0,
        total_count: 0
    },
    // pageSelect: [],
    praiseList: [], // 点赞列表
    content: "", // 文章内容 用于预览时的发布
    isPre: 1, // 是否是预览界面
    verInfo : "",
    adImg : "",    //广告图

    // 渲染完评论后的回调函数
    afterReplysRendered: function() {
        var newImgs = $(".comment img[data-original][loaded!=true]");
        newImgs.lazyload().attr("loaded", true);
    },

    // 评论点赞
    replyPraise: function(el) {
        el.praise_num = tool.toNumber(el.praise_num);
        el.isPraise = tool.toNumber(el.isPraise);
        if (window.server.islogin) {
            exchange(el);
            tool.singleWay("article-reply-praise", function(key) {
                var kit = this;
                debugger;
                el.praise_num = tool.toNumber(el.praise_num);
                el.isPraise = tool.toNumber(el.isPraise);
                ajax.getJSONWithFail(window.server.articleBase.praiseUrl, {
                    id: el.id,
                    type: "reply"
                })
                    .done(function(response) {
                        kit.resolve(key);
                    })
                    .fail(function() {
                        exchange(el);
                        kit.resolve(key);
                    });
            });
        } else {
            ajax.pjax(window.server.loginUrl);
        }
        return false;
    },

    // 文章回复
    replyLoading: false,

    // 由于avalon2.的BUG 使用v-model在ie中会报错  只能用jquery获取文本域的值
    articleReply: function(el) {
        // 判断内容不能为空

        var replyContentName;
        if (el.id) {
            replyContentName = "replyContent" + el.id;
        } else {
            replyContentName = "replyContent";
        }
        var replyContent = $("#" + replyContentName).val();
        // if($.trim(replyContent.replace(/\r\n/g,'')).length == 0){
        // 	return dialog.alert('抱歉，回复内容不能为空！');
        // }
        localStorage[replyContentName] = replyContent;

        if (window.server.islogin) {
            tool.singleWay("article-reply", function(key) {
                var kit = this;
                el.id ? (el.replyLoading = true) : (vmodel.replyLoading = true);
                ajax.postWithFail(window.server.articleBase.replyArticleUrl, {
                    article_id: window.server.articleBase.articleId,
                    content: replyContent,
                    parent_reply_id: el.id || 0,
                    format: 1
                })
                    .done(function(res) {
                        vmodel.replys.removeAll();
                        // vmodel.start = 0;
                        localStorage[replyContentName] = "";
                        $("#" + replyContentName).val("");
                        vmodel.loadBottomDisplay = true;
                        vmodel.loadBottomHTML =
                            "<i class='icon'></i><span>评论更新中...</span>";
                        if (vmodel.page.page_total != 0) {
                            _load(vmodel.page.page_total);
                        } else if (vmodel.page.page_total == 0) {
                            _load(1);
                        }

                        // el.id ? el.replyLoading = false : vmodel.replyLoading = false;
                        if (el.id) {
                            el.replyLoading = false;
                        } else {
                            vmodel.replyLoading = false;
                        }
                        kit.resolve(key);
                    })
                    .fail(function(res) {
                        if (res.code === 302) {
                            ajax.pjax(window.server.loginUrl);
                        }
                        if (el.id) {
                            el.replyLoading = false;
                        } else {
                            vmodel.replyLoading = false;
                        }
                        kit.resolve(key);
                    });
            });
        } else {
            ajax.pjax(window.server.loginUrl);
        }
    },
    // 回复上的操作可见值
    seeReplyValue: "",
    // 回复仅自己可见的操作
    seeReply: function(el) {
        var viewAccess;
        if (el.view_access == 0) {
            viewAccess = 1;
        } else {
            viewAccess = 0;
        }
        ajax.getWithFail(
            window.server.articleBase.replyViewUrl +
                "?id=" +
                el.id +
                "&type=" +
                viewAccess
        );
        _load(1, "asc");
    },
    // 删除回复
    deleReply: function(el) {
        dialog.confirm(
            "确认删除这条评论",
            function() {
                ajax.getWithFail(
                    window.server.articleBase.replyDeleteUrl +
                        "&id=" +
                        el.id +
                        "&uid=" +
                        el.uid +
                        "&username=" +
                        el.username
                )
                    .done(function(response) {
                        if (response.type == "succ") {
                            dialog.alert("删除成功");
                            setTimeout(function() {
                                _load(1, "asc");
                                // window.location.reload();
                            }, 1000);
                        } else {
                            dialog.alert("删除失败");
                        }
                    })
                    .fail(function() {
                        dialog.alert("很抱歉，发生了网络错误，请重试！");
                    });
            },
            function() {}
        );
    },
    amendText: "",
    // 修改回复直接跳转到编辑器
    amendReply: function(el) {
        ajax.jump(window.server.articleBase.updateReplyUrl + "?id=" + el.id);
        // if(vmodel.amendText == '' || vmodel.amendText != el.content){
        // 	vmodel.amendText = el.content;
        // }
        // vmodel.replys.forEach(function(item) {
        // 	item.showAmend = false;
        // })
        // el.showAmend = el.showAmend == 1 ? 0: 1;
        // el.showReply = 0;
    },
    // cancelAmend: function(el) {
    // 	el.showAmend = 0;
    // },
    // articlemAmend:function(el) {
    // 	ajax.postWithFail(window.server.articleBase.updateReplyUrl+'?id='+el.id,{
    // 		content:vmodel.amendText
    // 	}).done(function(response){
    // 		if(response.type == 'succ'){
    // 			// _load(1,'asc');
    // 			dialog.alert('修改成功');
    // 			setTimeout(function(){
    // 				window.location.reload();
    // 			},1000)
    // 		} else{
    // 			dialog.alert('修改失败');
    // 		}
    // 		// _load(1,'asc');
    // 	}).fail(function(){
    //               dialog.alert("很抱歉，发生了网络错误，请重试！");
    //           })
    // },
    // 评论回复
    replyReply: function(el) {
        el.showReply = el.showReply == 1 ? 0 : 1;
        el.showAmend = 0;
    },

    // 取消评论回复
    cancelReply: function(el) {
        el.showReply = 0;
    },

    // 评论回复
    openReply: function(el) {
        if (el.id) {
            ajax.jump(window.server.articleBase.reply + "&replyId=" + el.id);
        } else {
            ajax.jump(window.server.articleBase.reply);
        }
    },

    // 文章点赞
    articlePraise: function() {
        if (window.server.islogin) {
            tool.singleWay("article-praise", function(key) {
                var kit = this;
                if (vmodel.isPraise === 1) {
                    vmodel.isPraise = 0;
                    vmodel.praiseNum = vmodel.praiseNum - 1;
                } else {
                    vmodel.isPraise = 1;
                    vmodel.praiseNum = vmodel.praiseNum + 1;
                }
                ajax.getJSONWithFail(window.server.articleBase.praiseUrl, {
                    id: window.server.articleBase.articleId,
                    type: "article"
                })
                    .done(function(response) {
                        kit.resolve(key);
                    })
                    .fail(function() {
                        vmodel.isPraise = vmodel.isPraise == 1 ? 0 : 1;
                        kit.resolve(key);
                    });
            });
        } else {
            ajax.pjax(window.server.loginUrl);
        }
    },

    // 文章收藏
    articleHouse: function() {
        if (window.server.islogin) {
            tool.singleWay("article-house", function(key) {
                var kit = this;
                if (vmodel.isHouse === 1) {
                    vmodel.isHouse = 0;
                    vmodel.houseNum = vmodel.houseNum - 1;
                } else {
                    vmodel.isHouse = 1;
                    vmodel.houseNum = vmodel.houseNum + 1;
                }
                ajax.getJSONWithFail(window.server.articleBase.houseUrl, {
                    id: window.server.articleBase.articleId
                })
                    .done(function() {
                        kit.resolve(key);
                    })
                    .fail(function() {
                        vmodel.isHouse = vmodel.isHouse == 1 ? 0 : 1;
                        kit.resolve(key);
                    });
            });
        } else {
            ajax.pjax(window.server.loginUrl);
        }
    },

    // 预览发布
    publish: function() {
        if (window.server.islogin) {
            if (
                window.server.articleBase.title == "" ||
                window.server.articleBase.content == ""
            ) {
                return dialog.alert("标题或内容不能为空，请返回修改！");
            }
            tool.singleWay("publish", function(key) {
                var kit = this;
                ajax.postWithFail(window.server.articleBase.articleUrl, {
                    group_id: window.server.articleBase.group_id,
                    title: window.server.articleBase.title,
                    content: window.server.articleBase.content
                })
                    .done(function(response) {
                        ajax.jump(response.url);
                    })
                    .fail(function() {
                        kit.resolve(key);
                    });
            });
        } else {
            ajax.pjax(window.server.loginUrl);
        }
    },

    // 下拉选择页码
    showAllSelect: 0,
    // 显示下拉选择页码
    showSelect: function() {
        vmodel.showAllSelect = vmodel.showAllSelect == 1 ? 0 : 1;
    },
    // 选择某页
    selectPage: function(page) {
        if (page != vmodel.page.page) {
            _load(page, vmodel.replyOrder);
        }
        vmodel.showAllSelect = 0;
    },

    // 底部页码
    consultPagination: [],
    // 选择某页
    consultGoPage: function(page) {
        if (page.disable) {
            return;
        }
        _load(page.target, vmodel.replyOrder);
    },
    // 跳转新页面
    jump: function(url) {
        ajax.pjax(url);
    },
    // 编辑帖子
    editArticle: function() {
        ajax.jump("/article/update.html?id=" + vmodel.articleId);
    },
    jumpVip: function() {
        ajax.jump(window.server.articleBase.pcVipUrl);
    },
    toTopVisible: false, // 回到顶部显示判断值
    toTopPositionBottom: 337, // 回到顶部标签的初始高度
    recommendTop: 265, // 相关推荐的初始高度
    manageVisible: true, // 管子帖子标签显示判断值
    managePositionBottom: 407,
    // 返回顶部
    toTop: function() {
        tool.scrollTo($("#header"));
    },
    // 弹出管理弹窗
    showManagePop: function() {
        managePop.show();
    },
    nav: "top",
    // 切换管理选项
    toggleNav: function(type) {
        // vmodel.nav = type;
        if (type == "top" || type == "down") {
            vmodel.nav = type;
        } else if (type == "refined") {
            if (vmodel.isCream == 0) {
                dialog.confirm(
                    "确定加精帖子吗？",
                    function() {
                        ajax.getWithFail(vmodel.creamUrl + "&cream=1&oper=1")
                            .done(function(response) {
                                if (response.type == "succ") {
                                    dialog.alert("加精成功");
                                    setTimeout(function() {
                                        window.location.reload();
                                    }, 1000);
                                }
                            })
                            .fail(function() {
                                dialog.alert(
                                    "很抱歉，发生了网络错误，请重试！"
                                );
                            });
                    },
                    function() {}
                );
            } else {
                dialog.confirm(
                    "确定取消加精帖子吗？",
                    function() {
                        ajax.getWithFail(vmodel.creamUrl + "&cream=0&oper=0")
                            .done(function(response) {
                                if (response.type == "succ") {
                                    dialog.alert("取消成功");
                                    setTimeout(function() {
                                        window.location.reload();
                                    }, 1000);
                                }
                            })
                            .fail(function() {
                                dialog.alert(
                                    "很抱歉，发生了网络错误，请重试！"
                                );
                            });
                    },
                    function() {}
                );
            }
        } else if (type == "amend") {
            dialog.confirm(
                "确定要修改帖子吗？",
                function() {
                    ajax.jump("/article/update.html?id=" + vmodel.articleId);
                },
                function() {}
            );
        } else if (type == "delete") {
            dialog.confirm(
                "确定要删除帖子吗？",
                function() {
                    ajax.getWithFail(vmodel.deleteUrl)
                        .done(function(response) {
                            if (response.type == "succ") {
                                dialog.alert("删除成功");
                                // ajax.pjax(response.url);
                                setTimeout(function() {
                                    window.location.href = response.url + "";
                                }, 1000);
                            }
                        })
                        .fail(function() {
                            dialog.alert("很抱歉，发生了网络错误，请重试！");
                        });
                },
                function() {}
            );
        }
    },
    // 选择置顶开始时间
    startClick: function() {
        window.laydate(start);
    },
    // 选择置顶结束时间
    endClick: function() {
        window.laydate(end);
    },
    topId: "", // 置顶选项的id
    topAry: [], // 置顶一栏选项数组
    topChildAry: [], // 置顶二栏选项数组
    topSelected: "", // 置顶一栏选项值
    topChildSelected: "", // 置顶二栏选项值
    startTime: "", // 置顶开始时间
    endTime: "", // 置顶结束时间
    reasonTop: "", // 置顶原因
    reasonDown: "", // 下沉原因
    topUrl: "", // 置顶接口
    creamId: "", // 加精的id
    creamUrl: "", // 加精接口
    subUrl: "", // 下沉接口
    deleteUrl: "", // 删除接口
    replyOrder: "asc", // 回复顺序的默认值
    replyValue: "回复顺序", //
    replyOrderChecked: true, //
    pagePagination: [],
    replyAry: [
        {
            name: "回复顺序",
            id: 1
        },
        {
            name: "回复倒序",
            id: 2
        }
    ],
    showReplyChecked: 0,
    // 显示回复框
    showReply: function() {
        vmodel.showReplyChecked = vmodel.showReplyChecked == 1 ? 0 : 1;
    },
    // 回复顺序
    replyClick: function(item) {
        vmodel.replyValue = item.name;
        vmodel.showReplyChecked = 0;
        if (item.id == 1) {
            vmodel.replyOrderChecked = true;
            vmodel.replyOrder = "asc";
            _load(1, vmodel.replyOrder);
        } else {
            vmodel.replyOrder = "desc";
            _load(1, vmodel.replyOrder);
            vmodel.replyOrderChecked = false;
        }
    },
    adminValue: "切换账号",
    // 切换账号的用户列表
    userList: [],
    showAdminChecked: 0,
    // 显示可以切换的账号
    showAdmin: function() {
        vmodel.showAdminChecked = vmodel.showAdminChecked == 1 ? 0 : 1;
    },
    // 切换账号
    adminClick: function(item) {
        vmodel.adminValue = item.userName;
        ajax.getWithFail(
            window.server.articleBase.adminUserLoginUrl + "?uid=" + item.uid
        ).done(function(response) {
            if (response.type == "succ") {
                dialog.confirm(
                    "切换账号成功",
                    function() {
                        window.location.reload();
                    },
                    function() {}
                );
            } else {
                dialog.alert("切换账号失败");
            }
        });
        vmodel.showAdminChecked = 0;
    }
});

// 给评论数组增加 几个参数
function dispose(arr) {
    for (var i = 0; i < arr.length; i++) {
        arr[i].verInfo = "";

        if (arr[i].zmtType != '0'){
            arr[i].verInfo += "vericon ver" + arr[i].zmtType;
        }
        if (arr[i].isVip == true){
            arr[i].verInfo += "vip vericon";
        }

        arr[i].showReply = 0;
        arr[i].showAmend = 0;
        // arr[i].reply = {};
        arr[i].replyLoading = false;
        arr[i].replyText = localStorage["replyContent" + arr[i].id];
    }
    return arr;
}

// ajax获取评论
function _load(page, order) {
    tool.singleWay("article-reply-load", function(key) {
        var kit = this;
        var start = page > 1 ? (page - 1) * vmodel.page.page_size : 0;
        console.log("start", start);
        vmodel.replys.removeAll();
        vmodel.loadBottomDisplay = true;
        vmodel.loadBottomHTML =
            "<i class='icon'></i><span>正在加载中...</span>";
        // 改变url
        window.history.pushState(
            {},
            0,
            window.server.articleBase.pageUrl + page
        );
        if (order) {
            // ajax.getJSONWithFail(window.server.articleBase.replyUrl+'?id='+vmodel.articleId+'&order='+order+'&start')
            ajax.getJSONWithFail(window.server.articleBase.replyUrl, {
                id: window.server.articleBase.articleId,
                order: order,
                start: start,
                limit: vmodel.page.page_size
            })
                .done(function(response) {
                    vmodel.replyNum = response.msg.replyNum;
                    if (response.msg.replys.length === 0) {
                        // scrollKit && scrollKit.nomore();
                    } else {
                        var replyList = response.msg;
                        var page = replyList.page;
                        // console.log(dispose(replyList.replys))
                        // console.log(vmodel.replys.$model)
                        vmodel.page = page;
                        vmodel.consultPagination = pagination.init(
                            vmodel.page.total_count,
                            vmodel.page.page,
                            vmodel.page.page_size
                        );
                        vmodel.replys.pushArray(dispose(replyList.replys));
                    }

                    kit.resolve(key);
                    vmodel.loadBottomDisplay = false;
                    tool.scrollTo($("#comment"));
                })
                .fail(function() {
                    vmodel.loadBottomHTML = "<span>加载失败，请稍后再试</span>";
                    setTimeout(function() {
                        vmodel.loadBottomDisplay = false;
                    }, 3000);
                    kit.resolve(key);
                });
        } else {
            ajax.getJSONWithFail(window.server.articleBase.replyUrl, {
                id: window.server.articleBase.articleId,
                start: start,
                limit: vmodel.page.page_size
            })
                .done(function(response) {
                    vmodel.replyNum = response.msg.replyNum;
                    if (response.msg.replys.length === 0) {
                        // scrollKit && scrollKit.nomore();
                    } else {
                        var replyList = response.msg;
                        var page = replyList.page;
                        // console.log(dispose(replyList.replys))

                        // console.log(vmodel.replys.$model)
                        vmodel.page = page;
                        vmodel.consultPagination = pagination.init(
                            vmodel.page.total_count,
                            vmodel.page.page,
                            vmodel.page.page_size
                        );
                        vmodel.replys.pushArray(dispose(replyList.replys));
                    }

                    kit.resolve(key);
                    vmodel.loadBottomDisplay = false;
                    tool.scrollTo($("#comment"));
                })
                .fail(function() {
                    vmodel.loadBottomHTML = "<span>加载失败，请稍后再试</span>";
                    setTimeout(function() {
                        vmodel.loadBottomDisplay = false;
                    }, 3000);
                    kit.resolve(key);
                });
        }
    });
}
// 过滤器
avalon.filters.seeReply = function(i) {
    if (i == 0) {
        return "所有人可见";
    } else if (i == 1) {
        return "自己可见";
    }
};
// 监听置顶选项第一个select值的变化
vmodel.$watch("topSelected", function() {
    vmodel.topChildAry = [];
    vmodel.topAry.forEach(function(item) {
        if (vmodel.topSelected == item.name) {
            item.child.forEach(function(item2) {
                var topChildObj = {};
                topChildObj.name = item2.name;
                topChildObj.value = item2.value;
                vmodel.topChildAry.push(topChildObj);
            });
            vmodel.topChildSelected = item.child[0].name;
            vmodel.topId = item.child[0].value;
        }
    });
});
// 监听置顶选项第二个select值的变化
vmodel.$watch("topChildSelected", function() {
    vmodel.topChildAry.forEach(function(item) {
        if (vmodel.topChildSelected == item.name) {
            vmodel.topId = item.value;
        }
    });
});
export default {
    init: function() {
        window.vm = vmodel;

        var verInfo = '';

        if (window.server.articleBase.authorInfo.zmtType > 0){
            verInfo += " ver" + window.server.articleBase.authorInfo.zmtType;
        }
        if (window.server.articleBase.is_vip != '0'){
            verInfo += 'vip';
        }

        tool.setVMValues(vmodel, {
            articleId: window.server.articleBase.articleId,
            title: window.server.articleBase.title,
            replyNum: window.server.articleBase.replyNum,
            isPraise: tool.toNumber(window.server.articleBase.isPraise),
            isShare: tool.toNumber(window.server.articleBase.isShare),
            isVip: tool.toNumber(window.server.articleBase.is_vip),
            isHouse: tool.toNumber(window.server.articleBase.isHouse),
            praiseNum: tool.toNumber(window.server.articleBase.praiseNum),
            houseNum: tool.toNumber(window.server.articleBase.houseNum),
            shareNum: tool.toNumber(window.server.articleBase.shareNum || 0),
            isPre: window.server.articleBase.isPre ? 1 : 0,
            islogin: window.server.islogin ? 1 : 0,
            isTop: window.server.articleBase.isTop,
            isCream: window.server.articleBase.isCream,
            manageVisible: window.server.articleBase.isAdmin ? 1 : 0,
            topUrl: window.server.articleBase.topUrl,
            creamUrl: window.server.articleBase.creamUrl,
            subUrl: window.server.articleBase.subUrl,
            deleteUrl: window.server.articleBase.deleteUrl,
            verInfo : verInfo,
            adImg : window.server.articleBase.ad_img
        });

        //广告图
        if (window.server.articleBase.ad_img!= ''){
            setTimeout(function(){
                $('#adImg').attr('src' , window.server.articleBase.ad_img);
            } , 500);
        }

        // 置顶选项值，当是管理员的时候才有值
        if (window.server.articleBase.isAdmin) {
            var menu = window.server.articleBase.menu;
            for (var i = 0; i < menu.length; i++) {
                var topObj = {};
                topObj.name = menu[i].name;
                topObj.child = [];
                for (var j = 0; j < menu[i].child.length; j++) {
                    var topChildObj = {};
                    topChildObj.name = menu[i].child[j].name;
                    topChildObj.value = menu[i].child[j].value;
                    topObj.child.push(topChildObj);
                }
                vmodel.topAry.push(topObj);
            }
            vmodel.topSelected = vmodel.topAry[0].name;
            vmodel.topChildSelected = vmodel.topAry[0].child[0].name;
        }
        // 初始化可切换账号的用户名
        window.server.articleBase.userList.forEach(function(item) {
            var userObj = {};
            userObj.userName = item.username;
            userObj.uid = item.uid;
            vmodel.userList.push(userObj);
        });
        // 从cookies读取回复内容
        $("#replyContent").val(localStorage.replyContent);

        if (vmodel.isPre == 0) {
            // 评论列表
            var replyList = window.server.articleBase.replyList;
            vmodel.replys.pushArray(dispose(replyList.list));
            vmodel.page = replyList.page;
            // buildPageSelect(vmodel.page.page_total);
            vmodel.consultPagination = pagination.init(
                vmodel.page.total_count,
                vmodel.page.page,
                vmodel.page.page_size
            );
            for (
                let i = 0;
                i <= parseInt(vmodel.page.total_count / vmodel.page.page_size);
                i++
            ) {
                var obj = {};
                obj.target = i + 1;
                obj.checked = false;
                vmodel.pagePagination.push(obj);
            }
            // 点赞列表
            vmodel.praiseList = window.server.articleBase.praiseList;

            // 初始化百度分享
            window._bd_share_config = {
                common: {
                    bdSnsKey: {},
                    bdText: window.server.articleBase.shareData.title,
                    bdDesc: window.server.articleBase.shareData.desc,
                    bdMini: "2",
                    bdMiniList: false,
                    bdStyle: "1",
                    bdSize: "32",
                    bdUrl: window.server.articleBase.shareData.url,
                    bdPic: window.server.articleBase.shareData.thumb
                },
                share: {}
            };

            if (window._bd_share_main) {
                window._bd_share_main.init();
            } else {
                var script = document.createElement("script");
                script.src =
                    "//bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=" +
                    ~(-new Date() / 36e5);
                document.getElementsByTagName("head")[0].appendChild(script);
            }
        }

        // 回到顶部DIV状态
        tool.onWindowScroll.on(function(e, top) {
            if (top === 0) {
                vmodel.toTopVisible = false;
            } else {
                vmodel.toTopVisible = true;
            }
            var clientHeight = tool.getClientHeight(),
                scrollHeight = tool.getScrollHeight();
            // console.log(clientHeight);
            // console.log(scrollHeight);
            if (scrollHeight - clientHeight - top < 337) {
                try {
                    vmodel.toTopPositionBottom =
                        357 - (scrollHeight - clientHeight - top);
                    vmodel.managePositionBottom =
                        407 - (scrollHeight - clientHeight - top);
                } catch (e) {
                    console.log(e);
                }
            } else {
                vmodel.toTopPositionBottom = 20;
                vmodel.managePositionBottom = 70;
            }
            // 固定热门推荐
            if (top < 265) {
                // vmodel.recommendTop = 265 - top
                $(".recommend").css("top", 265 - top + "px");
            } else {
                // vmodel.recommendTop = 0
                $(".recommend").css("top", "0px");
            }
        });
        // 图片懒加载
        tool.delay(function() {
            var newImgs = $(".content img");
            newImgs.lazyload().attr("loaded", true);
        });

        // 首页帖子列表缩略图的懒加载
        $(".lazy-background").lazyload({
            effect: "fadeIn",
            placeholder:
                window.server.cdnHost + "/dest/quanzi/images/default200.jpg",
            threshold: 300
        });

        // 初始化弹框组件
        var p = popup.init().initPop;
        managePop = new p({
            id: ".manage-pop",
            width: 750,
            height: 500,
            top: "45%",
            okCallback: function() {
                if (vmodel.nav == "top") {
                    if (vmodel.isTop == 0) {
                        ajax.getWithFail(
                            vmodel.topUrl +
                                "&oper=1" +
                                "&top=" +
                                vmodel.topId +
                                "&top_start_time=" +
                                vmodel.startTime +
                                "&top_end_time=" +
                                vmodel.endTime +
                                "&reason=" +
                                vmodel.reasonTop
                        )
                            .done(function(response) {
                                if (response.type == "succ") {
                                    dialog.alert("置顶成功");
                                    setTimeout(function() {
                                        window.location.reload();
                                    }, 1000);
                                }
                            })
                            .fail(function() {
                                dialog.alert(
                                    "很抱歉，发生了网络错误，请重试！"
                                );
                            });
                    } else {
                        ajax.getWithFail(
                            vmodel.topUrl +
                                "&oper=0" +
                                "&top=0&reason=" +
                                vmodel.reasonTop
                        )
                            .done(function(response) {
                                if (response.type == "succ") {
                                    dialog.alert("取消置顶成功");
                                    setTimeout(function() {
                                        window.location.reload();
                                    }, 1000);
                                }
                            })
                            .fail(function() {
                                dialog.alert(
                                    "很抱歉，发生了网络错误，请重试！"
                                );
                            });
                    }
                } else if (vmodel.nav == "down") {
                    ajax.getWithFail(
                        vmodel.subUrl +
                            "&sub=1" +
                            "&reason=" +
                            vmodel.reasonDown
                    )
                        .done(function(response) {
                            if (response.type == "succ") {
                                dialog.alert("下沉成功");
                                setTimeout(function() {
                                    window.location.reload();
                                }, 1000);
                            }
                        })
                        .fail(function() {
                            dialog.alert("很抱歉，发生了网络错误，请重试！");
                        });
                }
            },
            cancelCallback: function() {
                // pop.hide();
            }
        });
    },
    clear: function() {
        tool.onWindowScroll.clear();
        tool.scrollUtil.clear();
        tool.setVMValues(vmodel, {
            replys: [],
            isPre: 1
            // start: 0
        });
    }
};
